export default {
      id: "oc-sangfor-usage",
      viewBox: "0 0 1040 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-sangfor",
      toString: function () {
        return this.url;
      }
    }